import { render, staticRenderFns } from "./ResourceForm.vue?vue&type=template&id=ade155b4&"
import script from "./ResourceForm.vue?vue&type=script&lang=js&"
export * from "./ResourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports